import React, { useEffect, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import { Button, FormControl, TextField } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';

interface ViewDetailsProps {
    onClose: () => void
    data: any
}

interface UserData {
    name: string;
    email: string;
    date?: Date;
    telephone: string
}

interface ResetPasswordField {
    name: keyof UserData;
    type: string;
    label: string;
    disable: boolean
}

const ViewDetails = (props: ViewDetailsProps) => {
    const resetPasswordField: ResetPasswordField[] = [
        { name: 'name', type: 'text', label: 'Name', disable: true },
        { name: 'email', type: 'text', label: 'Email', disable: true },
        { name: 'telephone', type: 'text', label: 'Telephone', disable: true },

    ]

    useEffect(() => {

    }, [props.data])

    const { control, handleSubmit, setValue, clearErrors } = useForm({

    });


    const [userData, setUserData] = useState<any>(props.data)

    console.log(userData, "User dataaaaaaa")

    console.log(props.data)
    return (
        <div>
            <div className="modal-heading">
                <h4>User Details</h4>
                <CloseIcon
                    className='modal-close-button'
                    onClick={() => { props.onClose() }}
                />
            </div>
            <div className='modal-body'>
                {resetPasswordField.map((item, index) => (
                    <div key={index} style={{ marginTop: '15px', width: '100%', display: 'flex' }}>
                        <TextField
                            type={item.type}
                            label={item.label}
                            variant="outlined"
                            value={userData[item.name]}
                            fullWidth
                        />


                    </div>
                ))}
            </div>
        </div>
    )
}

export default ViewDetails